import {
  FETCH_EXTRA_PAYMENT_PAYROLL_REQUEST,
  SAVE_PAYROLL_REQUEST,
  CHANGE_PAYROLL_STATUS_REQUEST,
} from './actionTypes';

// Fetch Extra Payments
export const fetchExtraPaymentPayroll = (unit_id) => ({
  type: FETCH_EXTRA_PAYMENT_PAYROLL_REQUEST,
  payload: {unit_id},
});

// Save Payroll
export const saveExtraPaymentPayroll = (payrollData) => ({
  type: SAVE_PAYROLL_REQUEST,
  payload: payrollData,
});

// Change Payroll Status
export const changeExtraPaymentPayrollStatus = (payload) => ({
  type: CHANGE_PAYROLL_STATUS_REQUEST,
  payload,
});
